import axios, { AxiosError } from 'axios';

import { API_BASE_URL } from '../env';

const STRATA_API_BASE_URL = API_BASE_URL.replace(/\/+$/, '');

export const novaOpsApi = axios.create({
  baseURL: `${STRATA_API_BASE_URL}/nova-ops`,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

novaOpsApi.interceptors.request.use(
  (config) => {
    config.withCredentials = true;
    return config;
  },
  (error) => Promise.reject(error),
);

novaOpsApi.interceptors.response.use(
  (response) => {
    if (
      response.data &&
      typeof response.data === 'object' &&
      'data' in response.data
    ) {
      return {
        ...response,
        data: response.data.data,
      };
    }

    return response;
  },
  (error: AxiosError<any>) => {
    if (!error.response) {
      error.message =
        'Could not reach Strata API. Check the Strata backend is running and restart the portal.';
    } else if (error.response.status === 401) {
      error.message =
        'Strata sign-in required. Sign in again before using customer operations.';
    } else if (error.response.status === 403) {
      error.message =
        'You do not have customer operations access in Strata.';
    }

    return Promise.reject(error);
  },
);

export default novaOpsApi;
